import FancyArrow from "@/assets/svgs/FancyArrow";
import { Typography } from "@graphy/ui";
import Image, { StaticImageData } from "next/image";
import { SectionHeadingType } from "../atoms/SectionHeading";

export type ProductStepsSectionPropType = {
  title: SectionHeadingType;
  description: string;
  steps: {
    image: StaticImageData;
    text: string;
    description?: string;
  }[];
};

const ProductStepsSection = ({
  title,
  description,
  steps,
}: ProductStepsSectionPropType) => {
  return (
    <div className="container flex flex-col gap-10 overflow-hidden">
      <div className="flex flex-col items-center justify-center gap-2">
        {/* TODO: Replace with SectionHeading */}
        {/* <SectionHeading heading={title} /> */}
        <h2 className="text-center text-title3 font-bold text-grey-4 sm:text-title1">
          {title.map(({ text, highlight }) => {
            return highlight ? (
              <span className="text-purple-3">{text}</span>
            ) : (
              text
            );
          })}
        </h2>
        <Typography
          fontSize="text-body"
          colorClass="text-grey-3"
          fontWeight="font-normal"
          className="mt-1"
          align="text-center"
        >
          {description}
        </Typography>
      </div>

      <div className="relative flex flex-col sm:flex-row sm:gap-6 sm:rounded-2xl sm:border sm:p-8">
        <div className="hidden sm:block">
          <FancyArrow className="absolute left-1/2 top-0 -translate-y-1/2" />
          <FancyArrow className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-90" />
          <FancyArrow className="absolute right-0 top-1/2 translate-x-1/2 translate-y-1/2 rotate-90" />
        </div>

        {steps.map((step, index) => {
          return (
            <>
              <div
                className="flex flex-1 flex-col items-center justify-center gap-3 rounded-2xl bg-purple-0 p-4 text-center text-grey-4"
                key={index}
              >
                <div className="h-30 flex-shrink-0 basis-16">
                  <Image src={step.image} alt={step.text} width={500} height={500}/> 
                </div>

                {/* {step.text} */}

                <h4 className="text-title-16 font-semibold">{step.text}</h4>
                {step.description && (
                  <p className="text-body-12">{step.description}</p>
                )}
              </div>
              {index !== steps.length - 1 && (
                <div className="relative h-12 w-px self-center bg-grey-4 sm:hidden">
                  <FancyArrow className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rotate-90" />
                </div>
              )}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default ProductStepsSection;
